import angular from 'angular';
import adminCompanyConfig from './config';

import adminCompany from '../../containers/admin-company-detail';

const adminCompanyModule = angular.module('meredicte.admin_company', [])
  .component('appAdminCompany', adminCompany)
  .config(adminCompanyConfig);

export default adminCompanyModule;



// WEBPACK FOOTER //
// ./src/modules/admin-company-detail/module.js